<template>
  <div class="kk-panel__main">
    <div
      data-test-id="sidebar-teams"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Teams,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Teams)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons[ProcessItemTypes.Team]" />
    </div>

    <!-- Players -->
    <div
      data-test-id="sidebar-players"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Players,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Players)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons[ProcessItemTypes.Player]" />
    </div>

    <!-- Processes -->
    <div
      data-test-id="sidebar-processes"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Processes,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Processes)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons[ProcessItemTypes.Normal]" />
    </div>

    <!-- Grid -->
    <div
      data-test-id="sidebar-grid"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Grids,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Grids)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons[ProcessItemTypes.Grid]" />
    </div>

    <!-- Business -->
    <div
      data-test-id="sidebar-business"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Businesses,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Businesses)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons[ProcessItemTypes.Business]" />
    </div>

    <!-- Options -->
    <div
      v-if="showOptions"
      data-test-id="sidebar-options"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Options,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Options)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons.Options" />
    </div>

    <!-- Styles -->
    <div
      data-test-id="sidebar-styles"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Styles,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Styles)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons.CustomStyles" />
    </div>

    <!-- grow container -->
    <div style="flex-grow: 1"></div>

    <!-- Settings -->
    <div
      data-test-id="sidebar-settings"
      class="kk-panel__main-item"
      :class="{
        'kk-panel__main-item-active': activeSubNavigation == SubNavigations.Settings,
        'kk-panel__main-item-open': isSubNavigationVisible,
      }"
      @click="toggleNavigation(SubNavigations.Settings)"
    >
      <custom-icon class="kk-panel__icon" :class-name="icons['settings']" />
    </div>
  </div>
</template>

<script>
import { icons, ProcessItemTypes } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";
import { SubNavigations } from "../../../utils/constants";

export default {
  components: { CustomIcon },
  data() {
    return {
      icons: icons,
      ProcessItemTypes: ProcessItemTypes,
      SubNavigations: SubNavigations,
      navigationItems: {
        teams: { icon: icons[ProcessItemTypes.Team], index: 0 },
        players: { icon: icons[ProcessItemTypes.Player], index: 1 },
        processes: { icon: icons[ProcessItemTypes.Normal], index: 2 },
        options: { icon: icons["Options"], index: 3 },
        styles: { icon: icons["style"], index: 4 },
        settings: { icon: icons["settings"], index: 5 },
      },
    };
  },
  computed: {
    isSubNavigationVisible() {
      return this.$store.state.panel.isSubNavigationVisible;
    },
    activeSubNavigation() {
      return this.$store.state.preferences.allPreferences?.activeSubNavigation;
    },
    current() {
      return this.$store.state.cells.current;
    },
    showOptions() {
      return this.current?.type === "grid";
    },
  },
  methods: {
    // Toggle the sub navigation
    // If the sub navigation is not visible, show it and set the active sub navigation
    toggleNavigation(itemKey) {
      const item = this.navigationItems[itemKey];
      if (!this.isSubNavigationVisible) {
        this.setSubNavigation(itemKey);
        this.$store.dispatch("panel/toggleSubNavigationVisibility");
      } else if (this.activeSubNavigation === itemKey) {
        this.$store.dispatch("panel/toggleSubNavigationVisibility");
      } else {
        this.setSubNavigation(itemKey);
      }
    },
    setSubNavigation(data) {
      this.$store.dispatch("preferences/update", { key: "activeSubNavigation", value: data });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.kk-panel {
  &__icon {
    font-size: 22px;
    color: @kk-color-primary-blue !important;
  }
  &__main {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    &-item {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
      background-color: #d5e4ff;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      position: relative;
      cursor: pointer;

      &-open {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

        &::before {
          content: "";
          position: absolute;
          right: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.2));
        }
      }

      &-active {
        background-color: #fff;
        color: #7f7f7f;
        cursor: pointer;
        &::before {
          background: none;
        }
      }
      &:hover:not(&-active) {
        background-color: #62dff7;
      }
    }
  }
}
</style>
